export default __webpack_public_path__ + "static/media/user-invite-config-icon.c2c23985.svg";